const e = {
  screenWidths: {
    l: "992px"
  },
  containerWidths: {
    medium: "966px"
  }
};
export {
  e as default
};
//# sourceMappingURL=index.es171.js.map
